import SUBMISSION_OF_NEW_TITLES from './SubmissionofNewTitles';
import SUBMISSION_OF_REPEAT_TITLES_WITH_IDENTICAL_CONTENT from './SubmissionofRepeatTitlesWithIdenticalContent';
import SUBMISSION_OF_CLASSIFIED_TITLES_WITH_NEW_EXTRA_FEATURES from './SubmissionofClassifiedTitlesWithNewExtraFeatures';
import SUBMISSION_OF_NEW_TITLES_FOR_EXPRESS_SERVICE from './SubmissionofNewTitlesForExpressService';
import SUBMISSION_OF_TITLES_RE_CLASSIFICATION from './SubmissionofTitlesForReClassification';
import SUBMISSION_OF_FILMS_WITH_PARTY_POLITICAL_CONTENT from './SubmissionOfFilmsWithPartyPoliticalContent';
import SUBMISSION_OF_TITLES_TO_OBTAIN_AN_INDICATIVE_RATING from './SubmissionofTitlesToObtainAnIndicativeRating';

const FilmClassificationforPublicDistribution = [
    {
        formID: 'submissionOfNewTitlesDistribution',
        title: 'Application Details',
        fieldIDTitle: 'title-details-title',
        multiple: true,
        fields: SUBMISSION_OF_NEW_TITLES,
        submitBtn: { id: 'review', title: 'Review' },
        addBtn: { id: 'add-new', title: 'Add New Title' }
    },
    {
        formID: 'submissionofRepeatTitlesWithIdenticalContentDistribution',
        title: 'Application Details',
        fieldIDTitle: 'title-details-title',
        multiple: true,
        fields: SUBMISSION_OF_REPEAT_TITLES_WITH_IDENTICAL_CONTENT,
        submitBtn: { id: 'review', title: 'Review' },
        addBtn: { id: 'add-new', title: 'Add New Title' }
    },
    {
        formID: 'submissionofClassifiedTitlesWithNewExtraFeaturesDistribution',
        title: 'Application Details',
        fieldIDTitle: 'title-details-title',
        multiple: true,
        fields: SUBMISSION_OF_CLASSIFIED_TITLES_WITH_NEW_EXTRA_FEATURES,
        submitBtn: { id: 'review', title: 'Review' },
        addBtn: { id: 'add-new', title: 'Add New Title' }
    },
    {
        formID: 'submissionofNewTitlesForExpressServiceDistribution',
        title: 'Application Details',
        fieldIDTitle: 'title-details-title',
        multiple: true,
        fields: SUBMISSION_OF_NEW_TITLES_FOR_EXPRESS_SERVICE,
        submitBtn: { id: 'review', title: 'Review' },
        addBtn: { id: 'add-new', title: 'Add New Title' }
    },
    {
        formID: 'submissionofTitlesForRe-classificationDistribution',
        title: 'Application Details',
        fieldIDTitle: 'title-details-title',
        multiple: true,
        fields: SUBMISSION_OF_TITLES_RE_CLASSIFICATION,
        submitBtn: { id: 'review', title: 'Review' },
        addBtn: { id: 'add-new', title: 'Add New Title' }
    },
    {
        formID: 'submissionOfFilmsWithPartyPoliticalContentDistribution',
        title: 'Application Details',
        fieldIDTitle: 'title-details-title',
        multiple: true,
        fields: SUBMISSION_OF_FILMS_WITH_PARTY_POLITICAL_CONTENT,
        submitBtn: { id: 'review', title: 'Review' },
        addBtn: { id: 'add-new', title: 'Add New Title' }
    },
    {
        formID: 'submissionofTitlesToObtainAnIndicativeRatingDistribution',
        title: 'Application Details',
        fieldIDTitle: 'title-details-title',
        multiple: true,
        fields: SUBMISSION_OF_TITLES_TO_OBTAIN_AN_INDICATIVE_RATING,
        submitBtn: { id: 'review', title: 'Review' },
        addBtn: { id: 'add-new', title: 'Add New Title' }
    }
];

export default FilmClassificationforPublicDistribution;
